<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer026">
<p class="part-number-with-part-title" id="_idParaDest-8" lang="en-US">PART TWO</p>
<p class="part-title-with-part-number" id="_idParaDest-9" lang="en-US">THE HOUR OF NOT QUITE RAIN</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781504081696-8.vue?47fe2694